var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-item py-2 px-4",on:{"dblclick":function($event){$event.preventDefault();return _vm.$parent.$parent.$emit('rightClicked', _vm.index)}}},[_vm._v(_vm._s(_vm.source.name))])}
var staticRenderFns = []

export { render, staticRenderFns }